export const lang = {
    title: 'Docker Services',
    services: 'services',
    installed_versions: 'installées',
    previous_versions: 'précédentes',
    show_log: 'Visualizer le journal'
};
